export const useSupportedMapboxCountries = () => {
  return [
    'US',
    'PT',
    'NZ',
    'LU',
    'LT',
    'LI',
    'IT',
    'GB',
    'FR',
    'ES',
    'DE',
    'CH',
    'CA',
    'BE',
    'AU',
    'AT',
  ];
};
